<template>
    <div class="row">
        <div class="col"> <one /> </div>
        <div class="col"> <two /> </div>
    </div>
</template>

<script>
import one from './one'
import two from './two'
export default {
    name: "",
    data() {
        return {
            
        };
    },
    methods: {
        
    },
    created() {

    },
    components: {
        one,
        two
    },
};
</script>

<style lang="less" scoped>
    .row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .col {
            width: 49.8%;
        }  
    }
 
</style>
